import React from 'react';
import { Chip } from '@mui/material';

type Tone = 'default' | 'primary' | 'warning' | 'info' | 'success';

interface StatusInfo {
  label: string;
  color: Tone;
}

const STATUS: Record<string, StatusInfo> = {
  draft: { label: 'Rascunho', color: 'default' },
  active: { label: 'Ativo', color: 'primary' },
  closed: { label: 'Fechado', color: 'warning' },
  result_pending: { label: 'Aguardando processar', color: 'info' },
  processed: { label: 'Processado', color: 'success' },
  inactive: { label: 'Inativo', color: 'default' },
};

interface Props {
  status: string;
}

const BolaoStatusChip: React.FC<Props> = ({ status }) => {
  const info = STATUS[status] || { label: status, color: 'default' as Tone };
  return <Chip size="small" label={info.label} color={info.color} />;
};

export default BolaoStatusChip;
